import { baseApiUrl } from 'shared/consts';

const V1 = '/v1';
const CASH_CREDIT_PREFIX = `${V1}/cash-credit`;
const LOAN_PROCESS_PREFIX = `${V1}/loan-process`;
const OTP_PREFIX = `${CASH_CREDIT_PREFIX}/otp`;
const PROCESS_PREFIX = `${CASH_CREDIT_PREFIX}/process`;

export const API = {
  loan: {
    get startCashProcess() {
      return `${PROCESS_PREFIX}/start`;
    },
    verifyOtp(processId: string) {
      return `${OTP_PREFIX}/${processId}/verify`;
    },
    get authLogin() {
      return `${V1}/auth/login`;
    },
    get authRefresh() {
      return `${V1}/auth/token/refresh`;
    },
    get completeDelivery() {
      return `${LOAN_PROCESS_PREFIX}/delivery`;
    },
    getProductInfo(product: string) {
      return `${V1}/products/types/LOAN?code=${product}`;
    },
    getImage(image: string) {
      return `${baseApiUrl}${V1}/media/loan/images/${image}.png`;
    },
    get giftCardDetails() {
      return `${V1}/gift-card`;
    },
    initOtp(processId: string) {
      return `${OTP_PREFIX}/${processId}/send`;
    },
    getOrderDetail(processId: string) {
      return `${PROCESS_PREFIX}/${processId}`;
    },
    nextCashProcessStep(processId: string) {
      return `${PROCESS_PREFIX}/${processId}/next`;
    },
  },
  questionnaire: {
    get getQuestionnaire() {
      return `${V1}/questionnaires/questions`;
    },
  },
  branch: {
    getBranch() {
      return `/api/delivery/v1/branches`;
    },
  },
  google: {
    get gtmSend() {
      return `/api${V1}/analytic`;
    },
  },
};
